import { render } from "./Input.vue?vue&type=template&id=4bf2b068"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"

import "./Input.vue?vue&type=style&index=0&id=4bf2b068&lang=css"
script.render = render

export default script